import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import numeral from "numeral";

const options = {
  legend: {
    display: false,
  },
  elements: {
    point: {
      radius: 0,
    },
  },
  maintainAspectRatio: false,
  tooltips: {
    mode: "index",
    intersect: false,
    callbacks: {
      label: function (tooltipItem, data) {
        return numeral(tooltipItem.value).format("+0,0");
      },
    },
  },
  scales: {
    xAxes: [
      {
        type: "time",
        time: {
          format: "MM/DD/YY",
          tooltipFormat: "ll",
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          display: false,
        },
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index, values) {
            return numeral(value).format("0a");
          },
        },
      },
    ],
  },
};

const buildChartData = (data, casesType) => {
  let chartData = [];
  let lastDataPoint;
  for (let date in data.cases) {
    if (lastDataPoint) {
      let newDataPoint = {
        x: date,
        y: data[casesType][date] - lastDataPoint,
      };
      chartData.push(newDataPoint);
    }
    lastDataPoint = data[casesType][date];
  }
  return chartData;
};

function LineGraph({ casesType = "cases" }) {
  const [data, setData] = useState({});
  const [bgcolor, setBgcolor] = useState("#cc1034a9");
  const [brcolor, setBrcolor] = useState("#cc1034");

  useEffect(() => {
    if (casesType === "recovered") {
      setBgcolor("#068506a9");
      setBrcolor("#068506a9");
    } else if (casesType === "deaths") {
      setBgcolor("#fb4443a9");
      setBrcolor("#fb4443");
    } else {
      setBgcolor("#cc1034a9");
      setBrcolor("#cc1034");
    }
  }, [casesType]);

  useEffect(() => {
    const fetchData = async () => {
      await fetch("https://disease.sh/v3/covid-19/historical/all?lastdays=300")
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          let chartData = buildChartData(data, casesType);
          setData(chartData);
        });
    };

    fetchData();
  }, [casesType]);

  return (
    <div className="card ">
      <div className="card-header">
        <h5>Worldwide new {casesType}</h5>
      </div>
      <div className="card-body">
        {data?.length > 0 && (
          <Line
            data={{
              datasets: [
                {
                  label: `worldwide ${casesType}`,
                  fill: true,
                  backgroundColor: bgcolor,
                  pointHoverRadius: 4,
                  pointHoverBackgroundColor: brcolor,
                  data: data,
                },
              ],
            }}
            options={options}
          />
        )}
      </div>
    </div>
  );
}

export default LineGraph;
